import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from '../corporate-service/corporate-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.css']
})
export class ConfigurationsComponent implements OnInit {
  configurationsForm: UntypedFormGroup;
  fundingSourceList = [];
  status = "active";
  submitted = false;
  levelOfServices = [];
  spaceTypesList = [];
  configurationsId;



  constructor(
    private fb : UntypedFormBuilder,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private activatedRoute : ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {

    if (this.activatedRoute.snapshot.url.length === 5 && this.activatedRoute.snapshot.url[4].path === 'edit') {
      this.configurationsId = this.activatedRoute.snapshot.url[3].path;
    }

    this.configurationsForm = this.fb.group({
      cooperate: ['', Validators.required],
      spaceTypes:  this.fb.array([])
    });

    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getCorporateUsers(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2]) => {

        if (res1) {
          this.fundingSourceList = res1;
        }

        if (res2) {
          this.spaceTypesList = res2;
        }

        if (this.configurationsId) {
          this.getConfigurationsbyId()
        }
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getCorporateUsers() {
    return this.corporateService
      .getCorporateUsers(this.status);

  }

  getConfigurationsbyId(){
    this.corporateService
      .getConfigurationsById(this.configurationsId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {

          this.configurationsForm.patchValue({
            cooperate: data.cooperate
          })
          const spaceTypes = Object.keys(data.spaceTypes).map(key => data.spaceTypes[key]);
          if(spaceTypes)
          this.addConfiguration(spaceTypes)

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getSpaceTypeList() {
    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  get form(){
    return this.configurationsForm.controls;
  }

  get spaceTypeForm() {
    return this.configurationsForm.get('spaceTypes') as UntypedFormArray;
  }

  addConfiguration(preSpaceTypesList?) {

    const items = this.configurationsForm.get('spaceTypes') as UntypedFormArray;

    if (preSpaceTypesList) {
      for (const spaceType of preSpaceTypesList) {
        items.push(
          this.fb.group({
            title: [spaceType.title, Validators.required],
            spaceType: [spaceType.spaceType, Validators.required],
            los: [spaceType.los, Validators.required]
          })
        );

      }
      return;
    }

    items.push(
      this.fb.group({
        title: ['', Validators.required],
        spaceType: ['', Validators.required],
        los:['', Validators.required]
      })
    );
  }

  removeConfigurationItem(index: any) {
      const items =  this.configurationsForm.get('spaceTypes')as UntypedFormArray;
      items.removeAt(index);
  }


  onSelectConfigurationItem(configurationItem) {
    if (!configurationItem.value.spaceType) {
      configurationItem.patchValue({
        los: ''
      });
      return;
    }

    const item = this.spaceTypesList.find(item => item._id === configurationItem.value.spaceType);
    configurationItem.patchValue({
      los: item.los
    });
  }


  onSubmit() {
    this.submitted = true;
    if (this.configurationsForm.invalid || !this.configurationsForm.value.spaceTypes.length) {
      return;
    }

    let payload;
    for (let item of this.configurationsForm.value.spaceTypes) {
      const trimmedTitle = item.title.trim();
      const trimmedItem = { 
        ...item,
        title: trimmedTitle 
      };
      if (!payload) {
        payload = {
          cooperate: this.configurationsForm.value.cooperate,
          spaceTypes: {
            [trimmedTitle]: trimmedItem
          }
        }
        continue;
      }

      payload = {
       ...payload,
        spaceTypes: {
          ...payload.spaceTypes,
          [trimmedTitle]: trimmedItem
        }
      }
    }

    this.corporateService
      .addConfiguration(payload, this.configurationsId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.router.navigate(['/credentialing/fundingsource'],{state: {isMapper: true}})
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });

  }


  ngOnDestroy(): void {
  }

}
